// src/pages/PrivacyPolicy.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy = () => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: isArabic ? 'Cairo, sans-serif' : 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    lineHeight: '1.6',
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left'
  };

  const headingStyle = {
    color: '#3498db',
    marginBottom: '20px',
    marginTop: '30px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px'
  };

  const subheadingStyle = {
    color: '#2c3e50',
    marginTop: '20px'
  };

  return (
    <div style={containerStyle}>
      {isArabic ? (
        // المحتوى باللغة العربية
        <>
          <h1 style={{ textAlign: 'center', color: '#3498db', marginBottom: '30px' }}>
            سياسة الخصوصية لتطبيق AtDelivery Driver
          </h1>
          
          <p style={{ color: '#95a5a6', fontStyle: 'italic' }}>تاريخ آخر تحديث: 20 مايو 2025</p>
          
          <h2 style={headingStyle}>مقدمة</h2>
          <p>مرحبًا بك في تطبيق AtDelivery. نحن ملتزمون بحماية خصوصيتك وضمان أمان معلوماتك الشخصية. تشرح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا وحمايتنا لبياناتك عند استخدام تطبيق AtDelivery Driver.</p>
          <p>تطبيق AtDelivery Driver هو جزء من نظام متكامل لإدارة المطاعم وتتبع طلبات التوصيل في الوقت الفعلي، حيث يربط بين المطاعم والسائقين من خلال منصة الويب www.atdelivery.net.</p>
          
          <h2 style={headingStyle}>المعلومات التي نجمعها</h2>
          
          <h3 style={subheadingStyle}>معلومات الحساب والملف الشخصي</h3>
          <ul>
            <li>الاسم الكامل</li>
            <li>رقم الهاتف</li>
            <li>البريد الإلكتروني</li>
            <li>صورة الملف الشخصي (اختيارية)</li>
            <li>معلومات السيارة ورقم الرخصة</li>
          </ul>
          
          <h3 style={subheadingStyle}>معلومات الموقع</h3>
          <ul>
            <li>موقعك الجغرافي في الوقت الفعلي أثناء استخدام التطبيق لتسهيل عمليات التوصيل</li>
            <li>مسارات التوصيل والمسافات المقطوعة</li>
          </ul>
          
          <h3 style={subheadingStyle}>معلومات الأجهزة والاستخدام</h3>
          <ul>
            <li>نوع الجهاز وإصدار نظام التشغيل</li>
            <li>معرف الجهاز الفريد</li>
            <li>توقيت وتكرار استخدام التطبيق</li>
            <li>بيانات الأداء وسجلات الأخطاء</li>
          </ul>
          
          <h3 style={subheadingStyle}>بيانات التطبيق</h3>
          <ul>
            <li>الطلبات المقبولة والمكتملة</li>
            <li>التقييمات والملاحظات</li>
            <li>رسوم التوصيل والمبالغ المحصلة</li>
            <li>محادثات الدعم والطوارئ</li>
          </ul>
          
          <h2 style={headingStyle}>كيف نستخدم معلوماتك</h2>
          <p>نستخدم المعلومات التي نجمعها للأغراض التالية:</p>
          <ul>
            <li><strong>توفير الخدمة</strong>: لتمكينك من استلام وتوصيل الطلبات للعملاء</li>
            <li><strong>تسهيل التواصل</strong>: بينك وبين المطاعم والعملاء وفريق الدعم</li>
            <li><strong>تتبع الأداء</strong>: مراقبة وقت التوصيل وجودة الخدمة</li>
            <li><strong>تحسين التطبيق</strong>: تحليل البيانات لتحسين ميزات وأداء التطبيق</li>
            <li><strong>الدفع والمحاسبة</strong>: لاحتساب الأرباح والرسوم</li>
            <li><strong>الأمان والحماية</strong>: منع الاحتيال وضمان سلامة جميع الأطراف</li>
          </ul>
          
          <h2 style={headingStyle}>مشاركة المعلومات</h2>
          <p>قد نشارك معلوماتك مع الأطراف التالية:</p>
          <ul>
            <li><strong>المطاعم</strong>: اسمك وموقعك الحالي وحالة التوصيل</li>
            <li><strong>العملاء</strong>: اسمك وموقعك الحالي أثناء توصيل طلباتهم</li>
            <li><strong>مزودي الخدمات</strong>: شركاء التكنولوجيا الذين يساعدوننا في تشغيل التطبيق (مثل Firebase و Google Maps)</li>
            <li><strong>الجهات القانونية</strong>: عند الضرورة للامتثال للمتطلبات القانونية</li>
          </ul>
          
          <h2 style={headingStyle}>التخزين ومدة الاحتفاظ بالبيانات</h2>
          <ul>
            <li>نحن نستخدم Firebase (من Google) لتخزين البيانات</li>
            <li>نحتفظ بسجلات الطلبات والتوصيل لمدة سنة واحدة</li>
            <li>يمكنك طلب حذف بياناتك الشخصية عند إغلاق حسابك</li>
          </ul>
          
          <h2 style={headingStyle}>أمان البيانات</h2>
          <p>نلتزم بحماية بياناتك من خلال:</p>
          <ul>
            <li>استخدام تقنيات التشفير المناسبة</li>
            <li>تطبيق الضوابط الأمنية والإدارية</li>
            <li>تقييد الوصول إلى البيانات الشخصية للموظفين المصرح لهم فقط</li>
            <li>المراجعة المنتظمة لتدابيرنا الأمنية</li>
          </ul>
          
          <h2 style={headingStyle}>حقوقك</h2>
          <p>كمستخدم لتطبيقنا، لديك الحق في:</p>
          <ul>
            <li>الوصول إلى بياناتك الشخصية</li>
            <li>تصحيح البيانات غير الدقيقة</li>
            <li>حذف بياناتك (مع مراعاة المتطلبات القانونية)</li>
            <li>الاعتراض على معالجة بياناتك</li>
            <li>سحب موافقتك في أي وقت</li>
          </ul>
          
          <h2 style={headingStyle}>التغييرات على سياسة الخصوصية</h2>
          <p>قد نقوم بتحديث سياسة الخصوصية من وقت لآخر. سيتم إخطارك بأي تغييرات جوهرية من خلال التطبيق أو عبر البريد الإلكتروني.</p>
          
          <h2 style={headingStyle}>الاتصال بنا</h2>
          <p>إذا كانت لديك أي أسئلة أو استفسارات حول سياسة الخصوصية أو ممارسات البيانات، يرجى التواصل معنا على:</p>
          <ul>
            <li>البريد الإلكتروني: info@atdelivery.net</li>
            <li>الموقع: www.atdelivery.net</li>
          </ul>
          
          <div style={{ marginTop: '50px', textAlign: 'center', color: '#7f8c8d', fontSize: '0.9em' }}>
            <p>© 2025 ATDelivery. جميع الحقوق محفوظة.</p>
          </div>
        </>
      ) : (
        // المحتوى باللغة الإنجليزية
        <>
          <h1 style={{ textAlign: 'center', color: '#3498db', marginBottom: '30px' }}>
            Privacy Policy for AtDelivery Driver App
          </h1>
          
          <p style={{ color: '#95a5a6', fontStyle: 'italic' }}>Last Updated: May 20, 2025</p>
          
          <h2 style={headingStyle}>Introduction</h2>
          <p>Welcome to AtDelivery Driver App. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and protect your data when you use the AtDelivery Driver App.</p>
          <p>The AtDelivery Driver App is part of an integrated system for restaurant management and real-time order tracking, connecting restaurants and drivers through the www.atdelivery.net web platform.</p>
          
          <h2 style={headingStyle}>Information We Collect</h2>
          
          <h3 style={subheadingStyle}>Account and Profile Information</h3>
          <ul>
            <li>Full name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Profile picture (optional)</li>
            <li>Vehicle information and license number</li>
          </ul>
          
          <h3 style={subheadingStyle}>Location Information</h3>
          <ul>
            <li>Your real-time geographic location while using the app to facilitate delivery operations</li>
            <li>Delivery routes and distances traveled</li>
          </ul>
          
          <h3 style={subheadingStyle}>Device and Usage Information</h3>
          <ul>
            <li>Device type and operating system version</li>
            <li>Unique device identifier</li>
            <li>Timing and frequency of app usage</li>
            <li>Performance data and error logs</li>
          </ul>
          
          <h3 style={subheadingStyle}>Application Data</h3>
          <ul>
            <li>Accepted and completed orders</li>
            <li>Ratings and feedback</li>
            <li>Delivery fees and amounts collected</li>
            <li>Support and emergency conversations</li>
          </ul>
          
          <h2 style={headingStyle}>How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li><strong>Providing the Service</strong>: To enable you to receive and deliver orders to customers</li>
            <li><strong>Facilitating Communication</strong>: Between you, restaurants, customers, and support team</li>
            <li><strong>Performance Tracking</strong>: Monitoring delivery time and service quality</li>
            <li><strong>Improving the App</strong>: Analyzing data to enhance app features and performance</li>
            <li><strong>Payment and Accounting</strong>: To calculate earnings and fees</li>
            <li><strong>Security and Protection</strong>: Preventing fraud and ensuring the safety of all parties</li>
          </ul>
          
          <h2 style={headingStyle}>Information Sharing</h2>
          <p>We may share your information with the following parties:</p>
          <ul>
            <li><strong>Restaurants</strong>: Your name, current location, and delivery status</li>
            <li><strong>Customers</strong>: Your name and current location while delivering their orders</li>
            <li><strong>Service Providers</strong>: Technology partners who help us operate the app (such as Firebase and Google Maps)</li>
            <li><strong>Legal Authorities</strong>: When necessary to comply with legal requirements</li>
          </ul>
          
          <h2 style={headingStyle}>Storage and Data Retention</h2>
          <ul>
            <li>We use Firebase (by Google) for data storage</li>
            <li>We retain order and delivery records for one year</li>
            <li>You can request deletion of your personal data when closing your account</li>
          </ul>
          
          <h2 style={headingStyle}>Data Security</h2>
          <p>We are committed to protecting your data through:</p>
          <ul>
            <li>Using appropriate encryption technologies</li>
            <li>Implementing security and administrative controls</li>
            <li>Restricting access to personal data to authorized employees only</li>
            <li>Regular review of our security measures</li>
          </ul>
          
          <h2 style={headingStyle}>Your Rights</h2>
          <p>As a user of our app, you have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Delete your data (subject to legal requirements)</li>
            <li>Object to the processing of your data</li>
            <li>Withdraw your consent at any time</li>
          </ul>
          
          <h2 style={headingStyle}>Changes to the Privacy Policy</h2>
          <p>We may update our Privacy Policy from time to time. You will be notified of any significant changes through the app or via email.</p>
          
          <h2 style={headingStyle}>Contact Us</h2>
          <p>If you have any questions or inquiries about the Privacy Policy or data practices, please contact us at:</p>
          <ul>
            <li>Email: info@atdelivery.net</li>
            <li>Website: www.atdelivery.net</li>
          </ul>
          
          <div style={{ marginTop: '50px', textAlign: 'center', color: '#7f8c8d', fontSize: '0.9em' }}>
            <p>© 2025 ATDelivery. All rights reserved.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default PrivacyPolicy;